'use client';

// The app-wide header is now the sleek minimal design (see SleekHeader).
// Re-exported as `Header` so existing imports across the app keep working.
export { SleekHeader as Header } from '@/components/SleekHeader';
